import * as React from "react";
import { forwardRef } from "react";
const SvgCloudUpload = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 40, height: 40, viewBox: "0 0 24 24", fill: "none", stroke: "#4d4d4d", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 13v8" }), /* @__PURE__ */ React.createElement("path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" }), /* @__PURE__ */ React.createElement("path", { d: "m8 17 4-4 4 4" }));
const ForwardRef = forwardRef(SvgCloudUpload);
export { ForwardRef as ReactComponent };
